export default __webpack_public_path__ + "static/media/wedding-cake.86561cfe.png";